import { render, staticRenderFns } from "./TipsList.vue?vue&type=template&id=6ddce70a&scoped=true"
import script from "./TipsList.vue?vue&type=script&lang=js"
export * from "./TipsList.vue?vue&type=script&lang=js"
import style0 from "./TipsList.vue?vue&type=style&index=0&id=6ddce70a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddce70a",
  null
  
)

export default component.exports